import { Component, Input, OnInit, inject, input, signal } from '@angular/core';

import { ContainerDescriptionComponent, FeatureContainerComponent } from '@frontend/casino-ui';

import { GameModel, Top10GameTileModel } from '../modular-casino/models/gametile.models';
import { ContainerDescriptionBindings } from '../modular-casino/models/modular-container.models';
import { SubcategoryModel } from '../modular-casino/models/modular-lmt-category.models';
import { GamesReaderService } from '../modular-casino/services/games-reader.service';
import { SwiperConfigService, SwiperOptionConfig } from '../modular-casino/services/swiper-config.service';
import { TopTenGameTileComponent } from './top-ten-game-tile/top-ten-game-tile.component';
import { ContainerConfigs, LobbyType } from './top-ten-games.model';

@Component({
    selector: 'cc-top-ten-games',
    imports: [FeatureContainerComponent, ContainerDescriptionComponent, TopTenGameTileComponent],
    templateUrl: './top-ten-games.component.html',
})
export class TopTenGamesComponent implements OnInit {
    enableFutureGrid = input(true);
    @Input({ required: true }) lobbyType: LobbyType;
    @Input({ required: true }) subCategory: SubcategoryModel;

    topTenGames: Top10GameTileModel[];

    swiperConfig: SwiperOptionConfig;
    containerDescriptionConfig: ContainerDescriptionBindings | undefined;
    private readonly swiperConfigService = inject(SwiperConfigService);
    private readonly gamesReaderService = inject(GamesReaderService);

    areGamesAvailable = signal<boolean>(false);

    ngOnInit(): void {
        this.getTopTenGames();
        this.getContainerDescription();
        this.getSwiperConfig();
    }

    private getSwiperConfig(): void {
        const isGamesAvailable = this.topTenGames.length > 0;
        this.swiperConfig = this.swiperConfigService.getChunkSwiperSize(isGamesAvailable, this.enableFutureGrid());
        this.areGamesAvailable.set(isGamesAvailable);
    }

    private getContainerDescription(): void {
        this.containerDescriptionConfig = this.gamesReaderService.getContainerDescriptionModel(
            this.subCategory.lmtCategoryId,
            this.subCategory.parentCategoryId,
            this.lobbyType,
        );
    }

    private getTrackingSection() {
        return this.subCategory.engCategoryName;
    }

    private getGameWithSection = (game: GameModel) => {
        return {
            ...game,
            gameSection: this.getTrackingSection(),
        };
    };

    private getTopTenGames(): void {
        let topTenGames = this.gamesReaderService.getGameModels(
            this.subCategory.lmtCategoryId,
            this.subCategory.parentCategoryId,
            this.lobbyType,
            ContainerConfigs.maxItems,
        );

        this.topTenGames = topTenGames.map((topTenGame: Top10GameTileModel) => {
            return {
                ...topTenGame,
                game: this.getGameWithSection(topTenGame.game),
            };
        });
    }
}
